import { Link } from 'react-router-dom'
import {
  articelsHomePageImages,
  postListNewImages,
  topAnimesImages,
  userProfileImages,
} from '../../services/images.service'
import ReactPlayer from 'react-player'
import { useState } from 'react'
import { TelegramShareButton, WhatsappShareButton } from 'react-share'
import toast from 'react-hot-toast'
import { getAnimeDetailsUrl } from '../../services/util.service'
import {
  mapAndTranslate,
  extractMinutes,
  translationMap,
} from '../../data/translationMap'
import { useSelector } from 'react-redux'
import { GreyBorderBottom } from '../ui/elements'
import {
  DiscordIcon,
  TelegramIcon,
  TiktokIcon,
  WhatsappIcon,
} from '../ui/icons/shared'

export function AnimeContent({ anime }) {
  const [isPlaying, setIsPlaying] = useState(false)
  const [openSection, setOpenSection] = useState(null)

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section)
  }

  // שליפת כל הביקורות והמשתמשים מה-Redux
  const reviews = useSelector((state) => state.reviewModule.reviews) || []

  // סינון ביקורות לאותה אנימה לפי anizone_id
  const animeReviews = reviews.filter(
    (review) => review.animeId === anime.anizone_id
  )

  return (
    <section className="flex flex-col items-start">
      <nav className="text-sm text-softText">
        <ol className="flex items-center gap-4">
          <li>
            <Link to="/" className="hover:underline">
              בית
            </Link>
          </li>
          <img src={articelsHomePageImages.arrowIcon} alt="arrow" />
          <li>
            <Link to="/animes" className="hover:underline">
              אנימות
            </Link>
          </li>
          <img src={articelsHomePageImages.arrowIcon} alt="arrow" />
          <li>
            <Link to={getAnimeDetailsUrl(anime)} className="hover:underline">
              {anime.title_hebrew || anime.title_english || anime.title}
            </Link>
          </li>
        </ol>
      </nav>

      <div className="flex flex-col gap-4 w-full mt-10">
        <div className="flex justify-between items-center">
          <h6 className="text-white text-lg">דירוגים</h6>
          <span className="text-muted text-sm">
            {Intl.NumberFormat('he-IL').format(anime.scored_by)}
          </span>
        </div>
        <div className="flex justify-between items-center">
          <h6 className="text-primary text-lg">דירוגים בישראל</h6>
          <span className="text-muted text-sm">
            {Intl.NumberFormat('he-IL').format(animeReviews.length)}
          </span>
        </div>

        <div className="my-8 ">
          <img
            className="w-full"
            src={postListNewImages.longLineDivider}
            alt="Divider"
          />
        </div>

        <div>
          <h5>טריילר</h5>
          <GreyBorderBottom className="w-full" />

          <div className="w-full mt-4 h-[200px] flex justify-center items-center relative">
            {!isPlaying && anime?.trailer?.url ? (
              <>
                {/* 🔹 בדיקה: אם אין תמונה ב-trailer, נשתמש ב-placeholder */}
                <img
                  src={
                    anime?.trailer?.images?.large_image_url ||
                    anime?.trailer?.images?.image_url ||
                    anime.images?.webp?.large_image_url ||
                    anime.images?.jpg?.large_image_url ||
                    anime.images?.webp?.image_url ||
                    anime.images?.jpg?.image_url ||
                    'https://placehold.co/320x180?text=No+Trailer'
                  }
                  alt={`${
                    anime?.title_hebrew || anime?.title_english || anime?.title
                  } Trailer Thumbnail`}
                  className="w-full h-full object-cover"
                />

                {/* 🔹 כפתור ניגון */}
                <button
                  className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 hover:bg-opacity-75 transition-all duration-300"
                  onClick={() => setIsPlaying(true)}
                  title="Play Trailer"
                >
                  <img
                    src={topAnimesImages.unSelectedTrailer}
                    alt="Play Button"
                    className="w-[80px] h-[80px] object-contain"
                  />
                </button>
              </>
            ) : anime?.trailer?.embed_url ? (
              <ReactPlayer
                url={anime.trailer.embed_url}
                playing
                controls
                width="100%"
                height="100%"
                config={{
                  youtube: {
                    playerVars: {
                      modestbranding: 1,
                      rel: 0,
                      showinfo: 0,
                    },
                  },
                }}
              />
            ) : (
              <div className="flex justify-center items-center w-full h-full bg-gray-900 text-white">
                אין טריילר זמין
              </div>
            )}
          </div>
        </div>

        <div className="flex justify-between items-center my-6">
          <p className="text-white text-lg">שמות נוספים</p>
          <button onClick={() => toggleSection(!openSection)}>
            <img
              src={
                openSection
                  ? userProfileImages.arrowUp
                  : userProfileImages.arrowDown
              }
              alt="Toggle Bio"
            />
          </button>
        </div>
        {openSection && (
          <div className="text-softText flex flex-col gap-2">
            {anime.title_japanese && <p>יפנית: {anime.title_japanese}</p>}
            {anime.title_synonyms.length > 0 && (
              <p>שמות נוספים: {anime.title_synonyms.join(', ')}</p>
            )}
          </div>
        )}

        <div className="my-4 ">
          <img
            className="w-full "
            src={postListNewImages.longLineDivider}
            alt="Divider"
          />
        </div>

        <div className="flex flex-col gap-6">
          <h5 className="text-white text-lg">מידע</h5>
          <div className="flex flex-col gap-6">
            {/* סוג */}
            <div className="flex justify-between items-center">
              <h6 className="text-muted text-sm">סוג</h6>
              <span className="text-softText text-sm">
                {anime?.type || 'לא צויין'}
              </span>
            </div>

            {/* פרק */}
            <div className="flex justify-between items-center">
              <h6 className="text-muted text-sm">פרקים</h6>
              <span className="text-softText text-sm">
                {anime?.episodes || 'לא צויין'}
              </span>
            </div>

            {/* קטגוריה */}
            <div className="flex justify-between items-center">
              <h6 className="text-muted text-sm">קטגוריה</h6>
              <span className="text-softText text-sm w-[80%] text-left">
                {anime?.genres?.length
                  ? mapAndTranslate(
                      anime.genres.map((g) => g.name),
                      translationMap
                    ).join(', ')
                  : 'לא צויין'}
              </span>
            </div>

            {/* תת קטגוריה */}
            <div className="flex justify-between items-center">
              <h6 className="text-muted text-sm">תת קטגוריה</h6>
              <span className="text-softText text-sm w-[70%] text-left">
                {anime?.themes?.length
                  ? mapAndTranslate(
                      anime.themes.map((t) => t.name),
                      translationMap
                    ).join(', ')
                  : 'לא צויין'}
              </span>
            </div>

            {/* דמוגרפיה */}
            <div className="flex justify-between items-center">
              <h6 className="text-muted text-sm">דמוגרפיה</h6>
              <span className="text-softText text-sm w-[70%] text-left">
                {anime?.demographics?.length
                  ? mapAndTranslate(
                      anime.demographics.map((d) => d.name),
                      translationMap
                    ).join(', ')
                  : 'לא צויין'}
              </span>
            </div>

            {/* מספר דקות */}
            <div className="flex justify-between items-center">
              <h6 className="text-muted text-sm">דקות</h6>
              <span className="text-softText text-sm">
                {extractMinutes(anime?.duration)}
              </span>
            </div>

            {/* מפיקים */}
            <div className="flex justify-between items-center">
              <h6 className="text-muted text-sm">מפיקים</h6>
              <span className="text-softText text-sm w-[70%] text-left">
                {anime?.producers?.length
                  ? anime.producers.map((p) => p.name).join(', ')
                  : 'לא צויין'}
              </span>
            </div>

            {/* זכויות שידור */}
            <div className="flex justify-between items-center">
              <h6 className="text-muted text-sm">זכויות</h6>
              <span className="text-softText text-sm w-[70%] text-left">
                {anime?.licensors?.length
                  ? anime.licensors.map((l) => l.name).join(', ')
                  : 'לא צויין'}
              </span>
            </div>

            {/* סטודיו */}
            <div className="flex justify-between items-center">
              <h6 className="text-muted text-sm">סטודיו</h6>
              <span className="text-softText text-sm w-[70%] text-left">
                {anime?.studios?.length
                  ? anime.studios.map((s) => s.name).join(', ')
                  : 'לא צויין'}
              </span>
            </div>
          </div>
        </div>

        <div className="my-4 ">
          <img
            className="w-full "
            src={postListNewImages.longLineDivider}
            alt="Divider"
          />
        </div>

        <div className="flex flex-col gap-6">
          <h5 className="text-white text-lg">שיתוף</h5>
          <div className="flex justify-between">
            <button
              onClick={async () => {
                await navigator.clipboard.writeText(window.location.href)
                toast.success('קישור הועתק !')
              }}
              className="text-muted text-sm hover:underline"
            >
              העתק קישור
            </button>
            <div className="flex gap-4 items-center">
              <WhatsappShareButton
                url={window.location.href}
                title={anime.title}
              >
                <WhatsappIcon className="text-primary w-6 h-6" />
              </WhatsappShareButton>
              <TelegramShareButton
                url={window.location.href}
                title={anime.title}
              >
                <TelegramIcon className="text-primary w-6 h-6" />
              </TelegramShareButton>

              <button
                onClick={async () => {
                  await navigator.clipboard.writeText(window.location.href)
                  toast.success('קישור הועתק לשיתוף בטיקטוק!')
                }}
              >
                <TiktokIcon className="text-primary w-6 h-6" />
              </button>

              <button
                onClick={async () => {
                  await navigator.clipboard.writeText(window.location.href)
                  toast.success('קישור הועתק לשיתוף בדיסקורד!')
                }}
              >
                <DiscordIcon className="text-primary w-6 h-6" />
              </button>
            </div>
          </div>
        </div>
        <div className="my-4 ">
          <img
            className="w-full "
            src={postListNewImages.longLineDivider}
            alt="Divider"
          />
        </div>

        {/* <div className="flex flex-col gap-4 mt-8">
          <Link to="/japan-trip">
            <img src={articelsHomePageImages.japanGuide} alt="japanGuide image" />
          </Link>
          <Link to="/anime-glossary">
            <img src={articelsHomePageImages.vocabulary} alt="Vocabulary image" />
          </Link>
        </div> */}
      </div>
    </section>
  )
}
